import { QRCodeCanvas } from 'qrcode.react';
import InstapayLogo from './../../../assets/images/IPN.svg';

const InstapayQrCode = ({ qrCode }) => {
    return (
        <div style={{ width: "100%", maxWidth: "400px", margin: "auto" }}>
            <div style={{ border: "2px solid #ccc", padding: "10px" }}>
                <QRCodeCanvas
                    value={qrCode}
                    size={512}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"H"}
                    imageSettings={{
                        src: InstapayLogo,
                        height: 120,
                        width: 100,
                        excavate: true,
                    }}
                />
            </div>
        </div>
    )
}


export default InstapayQrCode;